import React from 'react';
import {BaseIcon, iconDefaultProps, iconPropTypes} from './base-icon';
export const UnlockIcon = ({...props}) => (
	<BaseIcon {...props}>
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12.6 14.5C12.6 14.1686 12.3314 13.9 12 13.9C11.6687 13.9 11.4 14.1686 11.4 14.5V16.5C11.4 16.8314 11.6687 17.1 12 17.1C12.3314 17.1 12.6 16.8314 12.6 16.5V14.5Z"
				fill="#4C4C58"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 3.22499C10.9988 3.22499 10.0386 3.62272 9.3307 4.33067C8.62275 5.03862 8.22502 5.9988 8.22502 6.99999V9.60001H17C18.6569 9.60001 20 10.9432 20 12.6V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V12.6C4 10.9432 5.34315 9.60001 7 9.60001H7.02502V6.99999C7.02502 5.68054 7.54917 4.41513 8.48217 3.48214C9.41516 2.54914 10.6806 2.02499 12 2.02499C13.3195 2.02499 14.5849 2.54914 15.5179 3.48214C16.0355 3.99973 16.4272 4.61964 16.6735 5.29427C16.7871 5.60555 16.6269 5.95001 16.3156 6.06362C16.0043 6.17724 15.6598 6.017 15.5462 5.70572C15.3593 5.19374 15.0621 4.7234 14.6694 4.33067C13.9614 3.62272 13.0012 3.22499 12 3.22499ZM17 10.8H7C6.00589 10.8 5.2 11.6059 5.2 12.6V19C5.2 19.9941 6.00589 20.8 7 20.8H17C17.9941 20.8 18.8 19.9941 18.8 19V12.6C18.8 11.6059 17.9941 10.8 17 10.8Z"
				fill="#4C4C58"
			/>
		</svg>
	</BaseIcon>
);

UnlockIcon.propTypes = iconPropTypes;
UnlockIcon.defaultProps = iconDefaultProps;
